import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const IconButtonContainer = styled.span<{ $isActive: boolean }>`
  position: relative;
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.palette.text.primary : 'inherit'};
`;

export const Badge = styled.span<{ $hidden: boolean }>`
  // ${({ theme }) => typographyToCss(theme.typography.overline)};
  font-size: 0.9rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: ${({ theme }) => theme.spacing(-0.25)};
  right: ${({ theme }) => theme.spacing(-0.25)};

  padding: ${({ theme }) => `0 ${theme.spacing(0.75)}`};
  height: 1.4rem;
  min-width: 1.4rem;

  border-radius: ${({ theme }) => theme.spacing(2)};
  outline: 2px solid ${({ theme }) => theme.palette.background.default};
  background: ${({ theme }) => theme.palette.error.dark};
  color: ${({ theme }) => theme.palette.error.contrastText};

  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
`;
